import { c as _c } from "react/compiler-runtime";
import type { PrV2RevealCommentPayload } from '@/lib/pr-v2/reveal-comment';
import type { PrV2CommentResponse } from '@/lib/pr-v2/types';
import { useEffect } from 'react';
import { PR_V2_REVEAL_COMMENT_EVENT } from '@/lib/pr-v2/reveal-comment';

/** Auto-expands resolved threads when navigation targets a comment inside them. */
export function useExpandResolvedOnReveal(params) {
  const $ = _c(5);
  const {
    comments,
    shouldRenderResolvedSummary,
    setIsResolvedExpanded
  } = params;
  let t0;
  let t1;
  if ($[0] !== comments || $[1] !== setIsResolvedExpanded || $[2] !== shouldRenderResolvedSummary) {
    t0 = () => {
      if (!shouldRenderResolvedSummary) {
        return;
      }
      const commentIds = new Set(comments.map(_temp));
      const handleRevealComment = event => {
        const detail = event instanceof CustomEvent && typeof event.detail === "object" && event.detail ? event.detail as PrV2RevealCommentPayload : null;
        if (detail?.commentId && commentIds.has(detail.commentId)) {
          setIsResolvedExpanded(true);
        }
      };
      window.addEventListener(PR_V2_REVEAL_COMMENT_EVENT, handleRevealComment);
      return () => {
        window.removeEventListener(PR_V2_REVEAL_COMMENT_EVENT, handleRevealComment);
      };
    };
    t1 = [comments, shouldRenderResolvedSummary, setIsResolvedExpanded];
    $[0] = comments;
    $[1] = setIsResolvedExpanded;
    $[2] = shouldRenderResolvedSummary;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}
function _temp(c) {
  return c.githubCommentId;
}